function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.5491 27.1113V13.5823",
  stroke: "#434343",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M24.5197 29.519H16.5881L17.4527 27.1113H23.6552L24.5197 29.519Z",
  stroke: "#434343",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M20.549 13.5925C21.1819 13.5925 21.695 13.0783 21.695 12.4441C21.695 11.8098 21.1819 11.2957 20.549 11.2957C19.916 11.2957 19.403 11.8098 19.403 12.4441C19.403 13.0783 19.916 13.5925 20.549 13.5925Z",
  stroke: "#434343",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M26.9024 15.6272H14.1958",
  stroke: "#434343",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M11.3006 21.6514C11.2778 22.0286 11.3323 22.4064 11.4607 22.7617C11.5891 23.117 11.7887 23.4422 12.0472 23.7173C12.3056 23.9925 12.6176 24.2117 12.9637 24.3615C13.3099 24.5114 13.6829 24.5887 14.06 24.5887C14.4371 24.5887 14.8102 24.5114 15.1563 24.3615C15.5025 24.2117 15.8144 23.9925 16.0729 23.7173C16.3313 23.4422 16.5309 23.117 16.6593 22.7617C16.7877 22.4064 16.8422 22.0286 16.8195 21.6514L14.1957 15.6072L11.3006 21.6514Z",
  stroke: "#434343",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M11.3004 21.6514H16.8193",
  stroke: "#434343",
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M23.9971 21.6514C23.9971 22.3861 24.2883 23.0908 24.8068 23.6103C25.3252 24.1298 26.0284 24.4217 26.7616 24.4217C27.4947 24.4217 28.1979 24.1298 28.7163 23.6103C29.2348 23.0908 29.526 22.3861 29.526 21.6514L26.8922 15.6072L23.9971 21.6514Z",
  stroke: "#434343",
  strokeLinejoin: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M24.007 21.6514H29.5259",
  stroke: "#434343",
  strokeLinejoin: "round"
});

var SvgScalesPhone = function SvgScalesPhone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgScalesPhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/scales-phone.0e0da16f.svg";
export { ForwardRef as ReactComponent };